import { ISymbolData } from '../../../../../parseToTree.types';
import { IRemovePositionsInRangesOptions } from './removePositionsInRanges.types';

export const removePositionsInRanges = ({
  positions,
  ranges,
}: IRemovePositionsInRangesOptions): ISymbolData[] => {
  return positions.filter((position) => {
    const isInRange = ranges.some((range) => {
      return range.start <= position.start && position.end <= range.end;
    });

    return !isInRange;
  });
};
